<template>
  <div class="social-icons">
    <ul>
      <li>
        <a 
          target="_blank" 
          href="https://www.facebook.com/verkoop.logisch"
        >
          <font-awesome-icon 
            :icon="['fab', 'facebook-f']"
          /></a>
      </li>
      <li>
        <a 
          target="_blank" 
          href="https://www.instagram.com/_i_salu/"
        >
          <font-awesome-icon 
            :icon="['fab', 'instagram']"
          /></a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Share"
};
</script>
<style scoped>
.social-icons ul {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  text-align: center;
}
.social-icons ul li {
  display: inline-block;
  zoom: 1;
  *display: inline;
  vertical-align: middle;
}
.social-icons ul li a {
  display: block;
  font-size: 1.4em;
  margin: 0 5px;
  text-decoration: none;
  border: 1px solid #e7e7e7;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: #9b9b9b;
  position: relative;
  transition: all 0.2s ease-in;
}

.social-icons ul li a:hover {
  border-color: #4a90e2;
}

.social-icons ul li a:hover svg {
  color: #4a90e2;
}

.social-icons ul li a svg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transition: all 0.2s ease-in;
}
</style>
